const defaultCLFeatureSpecifications = [
    {
        labelKey: 'products.contactLenses.materialType',
        attribute: 'materialType'
    },
    {
        labelKey: 'products.contactLenses.lensType',
        attribute: 'lensType'
    },
    {
        labelKey: 'products.contactLenses.material',
        attribute: 'material'
    },
    {
        labelKey: 'products.contactLenses.waterContent',
        attribute: 'waterContent'
    },
    {
        labelKey: 'products.contactLenses.features.uv',
        attribute: 'hasUvProtection'
    }, 
];
const defaultSolutionsFeatureSpecifications = [
    {
        labelKey: 'products.solutions.lensTypeTarget',
        attribute: 'lensTypeTarget'
    },
    {
        labelKey: 'products.solutions.caseIncluded',
        attribute: 'caseIncluded'
    },
    {
        labelKey: 'products.solutions.minimumCycleTime',
        attribute: 'minimumCycleTime'
    },
    {
        labelKey: 'products.solutions.preservativeFree',
        attribute: 'preservativeFree'
    },
    {
        labelKey: 'products.solutions.maxTimeFrameInLensCase',
        attribute: 'maxTimeFrameInLensCase'
    },
    {
        labelKey: 'products.solutions.expirationAfterOpening',
        attribute: 'expirationAfterOpening'
    }, 
];

export { defaultCLFeatureSpecifications, defaultSolutionsFeatureSpecifications };
//# sourceMappingURL=product-feature-defaults.js.map
